import { render, staticRenderFns } from "./member-details.vue?vue&type=template&id=e48bd20c&scoped=true&"
import script from "./member-details.vue?vue&type=script&lang=js&"
export * from "./member-details.vue?vue&type=script&lang=js&"
import style0 from "./member-details.vue?vue&type=style&index=0&id=e48bd20c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48bd20c",
  null
  
)

export default component.exports